import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCourse } from './hooks';
import { Outlet, useNavigate } from 'react-router-dom';
import { useCourseByUserSlug } from './hooks';
import lazyLegacyRoot from "../../lazyLegacyRoot";
//LEGACY
import { useSlugName, useWebshopName } from '../../hooks/readFromUrls';
import CourseStore from '../../../../legacy/src/js/stores/Course';
const LegacyCourse = lazyLegacyRoot(() => import('../../../../legacy/src/js/components/Route/Course'), 'empty-div')

const CoursePreviewContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const course = useCourse();
  const slug = useSlugName();
  const ownerSlug = useWebshopName();

  // Use course hooks instead of direct API
  const { course, isLoading } = useCourseByUserSlug(ownerSlug, slug);


  useEffect(() => {
    if (course) {
      // Update modern Redux state
      dispatch(setCourse(course));

      // Update legacy CourseStore for legacy components
      const currentLegacyState = CourseStore.getInitialState();
      currentLegacyState.course = { ...course };

      CourseStore.triggerForLegacy(currentLegacyState);
    }
  }, [course, dispatch]);

  // Don't render legacy component until course is loaded
  if (isLoading || !course?.id) {
    return null; // Let the existing loading mechanism handle this
  }

  return (
    <>
      <LegacyCourse
        key={course.id}
        course={course}
        params={course}
        navigate={navigate}
      />
      <Outlet />
    </>
  );
}

export default CoursePreviewContainer;
